// Todos los países y territorios con prefijo telefónico internacional (UIT
// E.164), por código ISO 3166-1 alfa-2. La bandera sale del mismo código
// (flagcdn.com, ver NfFlag) y el nombre se traduce al idioma del sitio con
// Intl.DisplayNames; `en` es el respaldo si el navegador no lo soporta.
//
// Prefijos compartidos (p. ej. +1 de EE.UU. y Canadá, +7 de Rusia y
// Kazajistán, +44 del Reino Unido y Jersey): al reconocer un teléfono ya
// guardado gana el país de PREFERIDO_POR_PREFIJO. Los países del Plan de
// Numeración de Norteamérica con código de área propio (Caribe, territorios de
// EE.UU.) llevan el prefijo completo, p. ej. Jamaica +1876.
//
// Sin prefijo propio (no se listan): Antártida (Base Scott usa +64), Isla
// Bouvet, Islas Heard y McDonald, Tierras Australes Francesas.

export const PAISES_TELEFONO = [
    ['AF', '93', 'Afghanistan'], ['AX', '358', 'Åland Islands'], ['AL', '355', 'Albania'], ['DZ', '213', 'Algeria'],
    ['AS', '1684', 'American Samoa'], ['AD', '376', 'Andorra'], ['AO', '244', 'Angola'], ['AI', '1264', 'Anguilla'],
    ['AG', '1268', 'Antigua and Barbuda'], ['AR', '54', 'Argentina'], ['AM', '374', 'Armenia'], ['AW', '297', 'Aruba'],
    ['AU', '61', 'Australia'], ['AT', '43', 'Austria'], ['AZ', '994', 'Azerbaijan'], ['BS', '1242', 'Bahamas'],
    ['BH', '973', 'Bahrain'], ['BD', '880', 'Bangladesh'], ['BB', '1246', 'Barbados'], ['BY', '375', 'Belarus'],
    ['BE', '32', 'Belgium'], ['BZ', '501', 'Belize'], ['BJ', '229', 'Benin'], ['BM', '1441', 'Bermuda'],
    ['BT', '975', 'Bhutan'], ['BO', '591', 'Bolivia'], ['BQ', '599', 'Caribbean Netherlands'], ['BA', '387', 'Bosnia and Herzegovina'],
    ['BW', '267', 'Botswana'], ['BR', '55', 'Brazil'], ['IO', '246', 'British Indian Ocean Territory'], ['VG', '1284', 'British Virgin Islands'],
    ['BN', '673', 'Brunei'], ['BG', '359', 'Bulgaria'], ['BF', '226', 'Burkina Faso'], ['BI', '257', 'Burundi'],
    ['CV', '238', 'Cape Verde'], ['KH', '855', 'Cambodia'], ['CM', '237', 'Cameroon'], ['CA', '1', 'Canada'],
    ['KY', '1345', 'Cayman Islands'], ['CF', '236', 'Central African Republic'], ['TD', '235', 'Chad'], ['CL', '56', 'Chile'],
    ['CN', '86', 'China'], ['CX', '61', 'Christmas Island'], ['CC', '61', 'Cocos (Keeling) Islands'], ['CO', '57', 'Colombia'],
    ['KM', '269', 'Comoros'], ['CG', '242', 'Congo - Brazzaville'], ['CD', '243', 'Congo - Kinshasa'], ['CK', '682', 'Cook Islands'],
    ['CR', '506', 'Costa Rica'], ['CI', '225', "Côte d'Ivoire"], ['HR', '385', 'Croatia'], ['CU', '53', 'Cuba'],
    ['CW', '599', 'Curaçao'], ['CY', '357', 'Cyprus'], ['CZ', '420', 'Czechia'], ['DK', '45', 'Denmark'],
    ['DJ', '253', 'Djibouti'], ['DM', '1767', 'Dominica'], ['DO', '1809', 'Dominican Republic'], ['EC', '593', 'Ecuador'],
    ['EG', '20', 'Egypt'], ['SV', '503', 'El Salvador'], ['GQ', '240', 'Equatorial Guinea'], ['ER', '291', 'Eritrea'],
    ['EE', '372', 'Estonia'], ['SZ', '268', 'Eswatini'], ['ET', '251', 'Ethiopia'], ['FK', '500', 'Falkland Islands'],
    ['FO', '298', 'Faroe Islands'], ['FJ', '679', 'Fiji'], ['FI', '358', 'Finland'], ['FR', '33', 'France'],
    ['GF', '594', 'French Guiana'], ['PF', '689', 'French Polynesia'], ['GA', '241', 'Gabon'], ['GM', '220', 'Gambia'],
    ['GE', '995', 'Georgia'], ['DE', '49', 'Germany'], ['GH', '233', 'Ghana'], ['GI', '350', 'Gibraltar'],
    ['GR', '30', 'Greece'], ['GL', '299', 'Greenland'], ['GD', '1473', 'Grenada'], ['GP', '590', 'Guadeloupe'],
    ['GU', '1671', 'Guam'], ['GT', '502', 'Guatemala'], ['GG', '44', 'Guernsey'], ['GN', '224', 'Guinea'],
    ['GW', '245', 'Guinea-Bissau'], ['GY', '592', 'Guyana'], ['HT', '509', 'Haiti'], ['VA', '39', 'Vatican City'],
    ['HN', '504', 'Honduras'], ['HK', '852', 'Hong Kong'], ['HU', '36', 'Hungary'], ['IS', '354', 'Iceland'],
    ['IN', '91', 'India'], ['ID', '62', 'Indonesia'], ['IR', '98', 'Iran'], ['IQ', '964', 'Iraq'],
    ['IE', '353', 'Ireland'], ['IM', '44', 'Isle of Man'], ['IL', '972', 'Israel'], ['IT', '39', 'Italy'],
    ['JM', '1876', 'Jamaica'], ['JP', '81', 'Japan'], ['JE', '44', 'Jersey'], ['JO', '962', 'Jordan'],
    ['KZ', '7', 'Kazakhstan'], ['KE', '254', 'Kenya'], ['KI', '686', 'Kiribati'], ['XK', '383', 'Kosovo'],
    ['KW', '965', 'Kuwait'], ['KG', '996', 'Kyrgyzstan'], ['LA', '856', 'Laos'], ['LV', '371', 'Latvia'],
    ['LB', '961', 'Lebanon'], ['LS', '266', 'Lesotho'], ['LR', '231', 'Liberia'], ['LY', '218', 'Libya'],
    ['LI', '423', 'Liechtenstein'], ['LT', '370', 'Lithuania'], ['LU', '352', 'Luxembourg'], ['MO', '853', 'Macao'],
    ['MG', '261', 'Madagascar'], ['MW', '265', 'Malawi'], ['MY', '60', 'Malaysia'], ['MV', '960', 'Maldives'],
    ['ML', '223', 'Mali'], ['MT', '356', 'Malta'], ['MH', '692', 'Marshall Islands'], ['MQ', '596', 'Martinique'],
    ['MR', '222', 'Mauritania'], ['MU', '230', 'Mauritius'], ['YT', '262', 'Mayotte'], ['MX', '52', 'Mexico'],
    ['FM', '691', 'Micronesia'], ['MD', '373', 'Moldova'], ['MC', '377', 'Monaco'], ['MN', '976', 'Mongolia'],
    ['ME', '382', 'Montenegro'], ['MS', '1664', 'Montserrat'], ['MA', '212', 'Morocco'], ['MZ', '258', 'Mozambique'],
    ['MM', '95', 'Myanmar'], ['NA', '264', 'Namibia'], ['NR', '674', 'Nauru'], ['NP', '977', 'Nepal'],
    ['NL', '31', 'Netherlands'], ['NC', '687', 'New Caledonia'], ['NZ', '64', 'New Zealand'], ['NI', '505', 'Nicaragua'],
    ['NE', '227', 'Niger'], ['NG', '234', 'Nigeria'], ['NU', '683', 'Niue'], ['NF', '672', 'Norfolk Island'],
    ['KP', '850', 'North Korea'], ['MK', '389', 'North Macedonia'], ['MP', '1670', 'Northern Mariana Islands'], ['NO', '47', 'Norway'],
    ['OM', '968', 'Oman'], ['PK', '92', 'Pakistan'], ['PW', '680', 'Palau'], ['PS', '970', 'Palestine'],
    ['PA', '507', 'Panama'], ['PG', '675', 'Papua New Guinea'], ['PY', '595', 'Paraguay'], ['PE', '51', 'Peru'],
    ['PH', '63', 'Philippines'], ['PN', '64', 'Pitcairn Islands'], ['PL', '48', 'Poland'], ['PT', '351', 'Portugal'],
    ['PR', '1787', 'Puerto Rico'], ['QA', '974', 'Qatar'], ['RE', '262', 'Réunion'], ['RO', '40', 'Romania'],
    ['RU', '7', 'Russia'], ['RW', '250', 'Rwanda'], ['BL', '590', 'St. Barthélemy'], ['SH', '290', 'St. Helena'],
    ['KN', '1869', 'St. Kitts and Nevis'], ['LC', '1758', 'St. Lucia'], ['MF', '590', 'St. Martin'], ['PM', '508', 'St. Pierre and Miquelon'],
    ['VC', '1784', 'St. Vincent and Grenadines'], ['WS', '685', 'Samoa'], ['SM', '378', 'San Marino'], ['ST', '239', 'São Tomé and Príncipe'],
    ['SA', '966', 'Saudi Arabia'], ['SN', '221', 'Senegal'], ['RS', '381', 'Serbia'], ['SC', '248', 'Seychelles'],
    ['SL', '232', 'Sierra Leone'], ['SG', '65', 'Singapore'], ['SX', '1721', 'Sint Maarten'], ['SK', '421', 'Slovakia'],
    ['SI', '386', 'Slovenia'], ['SB', '677', 'Solomon Islands'], ['SO', '252', 'Somalia'], ['ZA', '27', 'South Africa'],
    ['GS', '500', 'South Georgia and South Sandwich Islands'], ['KR', '82', 'South Korea'], ['SS', '211', 'South Sudan'], ['ES', '34', 'Spain'],
    ['LK', '94', 'Sri Lanka'], ['SD', '249', 'Sudan'], ['SR', '597', 'Suriname'], ['SJ', '47', 'Svalbard and Jan Mayen'],
    ['SE', '46', 'Sweden'], ['CH', '41', 'Switzerland'], ['SY', '963', 'Syria'], ['TW', '886', 'Taiwan'],
    ['TJ', '992', 'Tajikistan'], ['TZ', '255', 'Tanzania'], ['TH', '66', 'Thailand'], ['TL', '670', 'Timor-Leste'],
    ['TG', '228', 'Togo'], ['TK', '690', 'Tokelau'], ['TO', '676', 'Tonga'], ['TT', '1868', 'Trinidad and Tobago'],
    ['TN', '216', 'Tunisia'], ['TR', '90', 'Türkiye'], ['TM', '993', 'Turkmenistan'], ['TC', '1649', 'Turks and Caicos Islands'],
    ['TV', '688', 'Tuvalu'], ['UM', '1', 'U.S. Outlying Islands'], ['VI', '1340', 'U.S. Virgin Islands'], ['UG', '256', 'Uganda'],
    ['UA', '380', 'Ukraine'], ['AE', '971', 'United Arab Emirates'], ['GB', '44', 'United Kingdom'], ['US', '1', 'United States'],
    ['UY', '598', 'Uruguay'], ['UZ', '998', 'Uzbekistan'], ['VU', '678', 'Vanuatu'], ['VE', '58', 'Venezuela'],
    ['VN', '84', 'Vietnam'], ['WF', '681', 'Wallis and Futuna'], ['EH', '212', 'Western Sahara'], ['YE', '967', 'Yemen'],
    ['ZM', '260', 'Zambia'], ['ZW', '263', 'Zimbabwe'],
].map(([code, dial, en]) => ({ code, dial, en }))

// Prefijo compartido → país que se elige al leer un teléfono ya guardado.
export const PREFERIDO_POR_PREFIJO = {
    '1': 'US', '7': 'RU', '39': 'IT', '44': 'GB', '47': 'NO', '61': 'AU', '64': 'NZ',
    '212': 'MA', '262': 'RE', '358': 'FI', '500': 'FK', '590': 'GP', '599': 'CW', '672': 'NF',
}

// Nombre del país en el idioma del sitio (cacheado por idioma).
const cache = {}
export function nombrePais(code, locale) {
    const loc = locale || 'es'
    if (!cache[loc]) {
        try {
            cache[loc] = new Intl.DisplayNames([loc], { type: 'region' })
        } catch (e) {
            cache[loc] = null
        }
    }
    const pais = PAISES_TELEFONO.find(p => p.code === code)
    if (cache[loc]) {
        try {
            const n = cache[loc].of(code)
            if (n && n !== code) return n
        } catch (e) { /* código desconocido para el navegador */ }
    }
    return pais ? pais.en : code
}

/**
 * Separa "+5491122334455" en { pais, numero }. Prueba primero los prefijos
 * más largos (+1876 antes que +1, +54 antes que +5). Si no reconoce ninguno
 * devuelve el texto tal cual como número.
 */
const POR_LARGO = [...PAISES_TELEFONO].sort((a, b) => b.dial.length - a.dial.length)
export function separarTelefono(tel) {
    const texto = (tel || '').trim()
    if (texto[0] !== '+') return { pais: '', numero: texto }
    const digitos = texto.slice(1)
    const p = POR_LARGO.find(x => digitos.startsWith(x.dial))
    if (!p) return { pais: '', numero: texto }
    const numero = digitos.slice(p.dial.length).replace(/^[\s-]+/, '')
    // +7: Kazajistán usa los números que empiezan con 6 o 7; el resto es Rusia.
    if (p.dial === '7') return { pais: /^[67]/.test(numero) ? 'KZ' : 'RU', numero }
    return { pais: PREFERIDO_POR_PREFIJO[p.dial] || p.code, numero }
}
